<template>
  <div class="pb20">
    <p class="mb16 f14">
      <i class="dl w4 h16 bgE1241A vam mr5"></i>
      <router-link to="/">首页</router-link>
      <Icon class="va-2" size=14 type="ios-arrow-forward" />
      <span class="c0077DA">公告</span>
    </p>

    <div class="demo-spin-col mh150 pr">
      <Spin fix v-show="listLoding">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>

      <ul v-if="listData.length > 0">
        <li class="bbE5E5E5 ptb10" v-for="(list,index) in listData">
          <router-link :to="{path: '/Notice/Detail', query: { id: list.noticeId, title: list.title, content: textSlice(list.noticeInfo) }}">
            <p class="f13 hl20 c333">{{list.title}}</p>

            <div class="fSpace c999 hl20">
              <p>{{list.publishDate ? list.publishDate.split(' ')[0] : ''}}</p>
              <p class="w80">
                <Icon color="#999" size=14 type="md-eye" />
                {{list.clickAmount}}
              </p>
            </div>
          </router-link>
        </li>

        <li class="hl40 tc" v-show="isMore"><span class="c0077DA btnh0077DA cp" @click="getMore">查看更多</span></li>
      </ul>
    </div>
  </div>
</template>

<script>
import store from '@/store/store';

let _this = '';
export default {
  store, // 引用

  data () {
    return {
      listLoding: true,
      isMore: false,

      listRequestData: {
        page: 1,
        rows: 8,
        sord: 'desc', // desc-降序  asc-升序
        sidx: 'publish_date'
      },

      listData: [],  // 列表
    }
  },
  methods: {
    // 获取列表
    getList () {
      this.listLoding = true;
      this.isMore = false;

      this.sendGet({
        url: '/web/notice/platform/ktb',
        data: this.listRequestData
      }, (result) => {
        // console.log("ack回调", result.data);
        this.listData = this.listData.concat(result.data.data);
        this.listLoding = false;
        this.isMore = result.data.data.length == this.listRequestData.rows ? true : false;
      }, (result) => {
        // console.log("其他回调", result);
      })
    },

    // 加载更多
    getMore () {
      this.listRequestData.page += 1;
      this.getList();
    },
  },
  created () {
    _this = this;
    this.getList();  // 获取分类
  }
}
</script>

<style>
ul,
li {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/NoticeIndex.vue